const HamburguerMenu = ({ color, type }) => {
  const regular = (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.333252 0H21.6666V2.66667H0.333252V0ZM0.333252 6.66667H21.6666V9.33333H0.333252V6.66667ZM0.333252 13.3333H21.6666V16H0.333252V13.3333Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default HamburguerMenu;
